import * as actionTypes from "../ActionTypes";

// SAVE
export const saveBulletinVideoRequest = (apiPayloadRequest, callback) => ({
  type: actionTypes.SAVE_BULLETIN_VIDEO_REQUEST,
  payload: { apiPayloadRequest },
  callback,
});

export const saveBulletinVideoSuccess = (data) => ({
  type: actionTypes.SAVE_BULLETIN_VIDEO_SUCCESS,
  payload: data,
});

export const saveBulletinVideoFailure = (error) => ({
  type: actionTypes.SAVE_BULLETIN_VIDEO_FAILURE,
  payload: error,
});

// UPDATE
export const updateBulletinVideoRequest = (apiPayloadRequest, callback) => ({
  type: actionTypes.UPDATE_BULLETIN_VIDEO_REQUEST,
  payload: { apiPayloadRequest },
  callback,
});

export const updateBulletinVideoSuccess = (data) => ({
  type: actionTypes.UPDATE_BULLETIN_VIDEO_SUCCESS,
  payload: data,
});

export const updateBulletinVideoFailure = (error) => ({
  type: actionTypes.UPDATE_BULLETIN_VIDEO_FAILURE,
  payload: error,
});

// DELETE
export const deleteBulletinVideoRequest = (payload, callback) => ({
  type: actionTypes.DELETE_BULLETIN_VIDEO_REQUEST,
  payload,
  callback,
});

export const deleteBulletinVideoSuccess = (data) => ({
  type: actionTypes.DELETE_BULLETIN_VIDEO_SUCCESS,
  payload: data,
});

export const deleteBulletinVideoFailure = (error) => ({
  type: actionTypes.DELETE_BULLETIN_VIDEO_FAILURE,
  payload: error,
});

// READ
export const readBulletinVideoRequest = (payload, callback) => ({
  type: actionTypes.READ_BULLETIN_VIDEO_REQUEST,
  payload,
  callback,
});

export const readBulletinVideoSuccess = (data) => ({
  type: actionTypes.READ_BULLETIN_VIDEO_SUCCESS,
  payload: data,
});

export const readBulletinVideoFailure = (error) => ({
  type: actionTypes.READ_BULLETIN_VIDEO_FAILURE,
  payload: error,
});
